//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      localSearchString: '',
      filters: {
        searchString: '',
        dateCreatedFrom: '',
        dateCreatedTo: '',
      },
    };
  },

  computed: {
    ...mapState('p2pArbitratorsList', ['filterLists']),
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  created() {
    this.setFilters({});
  },

  methods: {
    ...mapActions('p2pArbitratorsList', ['setFilters']),

    handleSearchBlur() {
      this.filters.searchString = this.localSearchString;
    },
  },
};
